import React from 'react'

const ExpandArrowIcon = () => {
    return (

<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16">
  <path id="Path_21174" data-name="Path 21174" d="M.293.293a1,1,0,0,1,1.414,0l7,7a1,1,0,0,1,0,1.414l-7,7A1,1,0,0,1,.293,14.293L6.586,8,.293,1.707A1,1,0,0,1,.293.293Zm8,0a1,1,0,0,1,1.414,0l7,7a1,1,0,0,1,0,1.414l-7,7a1,1,0,0,1-1.414-1.414L14.586,8,8.293,1.707A1,1,0,0,1,8.293.293Z" fill="#fff" fill-rule="evenodd" />
</svg>


)
}

export default ExpandArrowIcon